export default "__VITE_ASSET__B4V5DmJt__"